import type {
  DeletePaymentCardResponse,
  GetPaymentCardResponse,
  GetPaymentServicesResponse,
  SavePaymentCardRequest,
  SavePaymentCardResponse,
  ServiceTokenizationConfig,
  TokenizationConfigResponse,
} from '../queries/paymentCard/types';

import apiService from './apiService';

/**
 * Payment Card V2 API
 *
 * Simplified API for managing user's saved credit card.
 * No payment service ID or instrument ID required.
 */

/** Get the user's saved payment card (or null if none) */
export async function getPaymentCard(): Promise<GetPaymentCardResponse> {
  const response = await apiService.getApi().get<GetPaymentCardResponse>('/me/payment-card');
  return response.data;
}

/** Save a new payment card using Till transaction token */
export async function savePaymentCard(
  request: SavePaymentCardRequest,
): Promise<SavePaymentCardResponse> {
  const response = await apiService
    .getApi()
    .post<SavePaymentCardResponse>('/me/payment-card', request);
  return response.data;
}

/** Delete the user's saved payment card (idempotent) */
export async function deletePaymentCard(): Promise<DeletePaymentCardResponse> {
  const response = await apiService.getApi().delete<DeletePaymentCardResponse>('/me/payment-card');
  return response.data;
}

/** Get Till SDK tokenization config for card capture */
export async function getTokenizationConfig(): Promise<TokenizationConfigResponse> {
  const response = await apiService
    .getApi()
    .get<TokenizationConfigResponse>('/me/payment-card/tokenization');
  return response.data;
}

/** Get available payment services for the current shop */
export async function getPaymentServices(): Promise<GetPaymentServicesResponse> {
  const response = await apiService
    .getApi()
    .get<GetPaymentServicesResponse>('/me/payment-services');
  return response.data;
}

/** Get tokenization config for a specific payment service */
export async function getServiceTokenization(
  serviceId: string,
): Promise<ServiceTokenizationConfig> {
  const response = await apiService
    .getApi()
    .get<ServiceTokenizationConfig>(`/me/payment-services/${serviceId}/tokenization`);
  return response.data;
}
